import React from 'react'

import Drawer from '@/components/common/Drawer'
import { useSearchContext } from '@/components/search/context'
import SbirFilter from '@/components/search/Sbir/Filter'
import SearchResponseDisplay from '@/components/search/SearchResponseDisplay'
import Toolbar from '@/components/search/Toolbar'

import { useCycledPlaceholder } from '@/hooks/search/useCycledPlaceholder'

import type { NextPageWithLayout } from '@/types/next'
import type { SbirSearchFilter } from '@/types/sbir/Filter'

const REQUIRED_TAG_NAMES: string[] = ['Agency', 'Branch', 'Phase', 'Program']

const PLACEHOLDERS = [
  'Cybersecurity solutions for homeland defense SBIR/STTRs',
  'Aerospace and aviation technology development grants',
  'Medical research and healthcare innovation funding',
  'Advanced robotics and AI systems for defense applications',
  'Clean energy breakthroughs seeking SBIR/STTR support',
  'Advanced robotics and AI systems for defense applications',
  'Clean energy breakthroughs seeking SBIR/STTR support',
  'Space exploration and satellite technology innovations',
  'Biotechnology and pharmaceutical research opportunities',
  'Advanced materials and manufacturing processes',
  'Quantum computing and cryptography solutions',
  'Agricultural technology and food security research',
  'Smart cities and infrastructure development',
  'Renewable energy storage and distribution systems',
]

const Search: NextPageWithLayout = () => {
  const {
    autoSubmit,
    filter,
    filterDrawerIsOpen,
    filterHeaderConfig,
    setFilter,
    toggleDrawer,
  } = useSearchContext()

  const { placeholder } = useCycledPlaceholder({ placeholders: PLACEHOLDERS })

  const handleSaveChanges = (filter: SbirSearchFilter) => {
    setFilter({
      type: 'sbir',
      filter: filter,
    })
  }

  return (
    <div className="flex w-full h-full bg-white dark:bg-primary-900">
      <div className="hidden lg:flex flex-col overflow-y-auto gap-y-4 pb-4 pt-3 lg:w-[20%] 3xl:w-1/6 5xl:w-[13%] border-r border-primary-300 dark:border-primary-800">
        {filter && filter.type === 'sbir' && (
          <SbirFilter
            filter={filter.filter}
            autoSubmit={true} // need this to save changes automatically
            onSaveChanges={handleSaveChanges}
            headerConfig={filterHeaderConfig}
            showApply={!autoSubmit}
          />
        )}
      </div>
      <div className="lg:hidden">
        {filter && filter.type === 'sbir' && (
          <Drawer open={filterDrawerIsOpen} toggleDrawer={toggleDrawer}>
            <SbirFilter
              filter={filter.filter}
              autoSubmit={true} // need this to save changes automatically
              onSaveChanges={handleSaveChanges}
              headerConfig={filterHeaderConfig}
              showApply={!autoSubmit}
            />
          </Drawer>
        )}
      </div>
      <div className="flex flex-col w-full lg:w-[80%] 3xl:w-5/6 5xl:w-[87%]">
        <div className="border-b border-primary-300 dark:border-primary-800">
          <Toolbar placeholder={placeholder} />
        </div>
        <SearchResponseDisplay requiredTagNames={REQUIRED_TAG_NAMES} />
      </div>
    </div>
  )
}

export default Search
